module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Datos de venta")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "text-xs-right": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": ""
    }
  }, [(_vm.isQuotation) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Imprimir Comanda'
      }),
      expression: "{ html: 'Imprimir Comanda' }",
      arg: "left"
    }],
    staticClass: "mr-2 btn-ticket",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "info": ""
    },
    on: {
      "click": _vm.downloadTicket
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sale.typeDocument.name !== 'COTIZACION') ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar Venta'
      }),
      expression: "{ html: 'Descargar Venta' }",
      arg: "left"
    }],
    staticClass: "mr-2",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "info": ""
    },
    on: {
      "click": _vm.downloadSale
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sale.typeDocument.name === 'COTIZACION') ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-2": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar Cotización'
      }),
      expression: "{ html: 'Descargar Cotización' }",
      arg: "left"
    }],
    staticClass: "mr-4",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "info": ""
    },
    on: {
      "click": _vm.downloadQuotation
    }
  }, [_c('v-icon', [_vm._v("cloud_download")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sale.typeDocument.name !== 'COTIZACION') ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "pr-3": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar Venta por Categorias'
      }),
      expression: "{ html: 'Descargar Venta por Categorias' }",
      arg: "left"
    }],
    staticClass: "mr-2",
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "small": "",
      "warning": ""
    },
    on: {
      "click": _vm.downloadSaleCategory
    }
  }, [_c('v-icon', [_vm._v("donut_small")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showDownloadBtn) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-right": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": "",
      "pr-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "px-0": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar ZIP'
      }),
      expression: "{ html: 'Descargar ZIP' }",
      arg: "left"
    }],
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "warning": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.openDownloadView('zip')
      }
    }
  }, [_c('v-icon', [_vm._v("receipt")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showDownloadBtn) ? _c('v-flex', {
    attrs: {
      "xs2": "",
      "flex": "",
      "xs-2": "",
      "text-xs-right": "",
      "pr-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": "",
      "pr-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "px-0": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Descargar ZIP'
      }),
      expression: "{ html: 'Descargar ZIP' }",
      arg: "left"
    }],
    attrs: {
      "dark": "",
      "fab": "",
      "icon": "",
      "warning": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.openDownloadView('zip')
      }
    }
  }, [_c('v-icon', [_vm._v("receipt")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNº Doc:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.numDocument))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tSucursal:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.sucursalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tCliente:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.customer.typePerson.fullName))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.customer.typePerson.documentName) + ":\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.customer.typePerson.documentNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tModo de pago:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.payment.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tTipo de Doc:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.sale.typeDocument.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tFecha:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.sale.localDate.date)))])])])])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sale.commentary),
      expression: "sale.commentary"
    }],
    attrs: {
      "xs12": "",
      "mt-3": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Observación:")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-textarea input-note mt-2",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "rows": 2,
      "textarea": "",
      "readonly": "",
      "value": _vm.sale.commentary
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table mt-3",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-search": false,
      "include-delete": false,
      "include-export-to-excel": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.productCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.productName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.price), _vm.symbol)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.subTotal), _vm.symbol)))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-1": "",
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    staticClass: "footer-bar-grey",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\tCargo al Consumo\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-title"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale ? _vm.sale.tip : ''), _vm.symbol)))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-subheader', {
    staticClass: "footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\t+\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\tSubtotal\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-content"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.subtotal), _vm.symbol)))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-subheader', {
    staticClass: "footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\t+\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title"
  }, [_vm._v("\n\t\t\t\t\t\tIGV\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-content"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.taxes), _vm.symbol)))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "footer-bar-white",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title blue"
  }, [_vm._v("\n\t\t\t\t\t\t-dsct\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-content"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.discount), _vm.symbol)))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "footer-bar-blue",
    attrs: {
      "xs7": ""
    }
  }, [_c('v-subheader', {
    staticClass: "justify-center footer-bar-title white"
  }, [_vm._v("\n\t\t\t\t\t\tTotal\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footer-bar-title white"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(_vm.sale.amount), _vm.symbol)))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    on: {
      "click": _vm.goToBack
    }
  }, [_vm._v("\n\t\t\t\tRegresar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t¿Desea anular la venta?\n\t\t\t")]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    staticClass: "btn-add btn-grey mr-2",
    nativeOn: {
      "click": function($event) {
        _vm.closeConfirm($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-add",
    nativeOn: {
      "click": function($event) {
        _vm.cancelSale($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tAceptar\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-165158d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/sales/Detail.vue
// module id = 1590
// module chunks = 66